import { getPropertyTooltip } from './properties_rendering';

export const ClassificationTypes = {
    BINARY: 'Binary',
    REGRESSION: 'Regression',
};

export const Directionality = {
    NOT_APPLICABLE: 'N/A',
    MINIMIZE: 'More negative is better',
    MAXIMIZE: 'More positive is better',
    ONEHUNDRED: 'Closer to 100% is better',
    ZERO: 'Closer to 0% is better',
};

/**
 * Prepare property group info for ScopedProperty global metadata.
 * @param {{ groupMeta: { label: string, propApplicability },
 * propertyInfo: { [propName: string]: {
 * label, description, unit, directionality, range, goodRange, r2, classificationType
 * }}}}
 * @returns {{ metadata, properties: { metadata: { label, description, tooltip } } }}
 */
export function preparePropertyGroupMetadata({ groupMeta, propertyInfo, tooltipHeading }) {
    return {
        metadata: groupMeta,
        properties: Object.entries(propertyInfo).reduce((acc, [propName, propInfo]) => ({
            ...acc,
            [propName]: {
                metadata: {
                    label: propInfo.label,
                    description: propInfo.description,
                    tooltip: getPropertyTooltip(tooltipHeading, propInfo),
                },
            },
        }), {}),
    };
}
